import { Grid } from '@mui/material';
import { StatCard } from '../StatCard';
import { OrderDto, OrderState } from 'desk-common';
import { useMemo } from 'react';

interface Props {
  orders: OrderDto[];
  onStatClick?: (state: OrderState | null) => void;
  selectedState?: OrderState | null;
}

export function OrdersStats({ orders, onStatClick, selectedState }: Props) {
  const stats = useMemo(() => {
    const result = {
      total: orders.length,
      borradores: 0,
      pendientes: 0,
      preaprobadas: 0,
    };

    for (const order of orders) {
      switch (order.state) {
        case OrderState.BORRADOR:
          result.borradores++;
          break;
        case OrderState.PENDIENTE_APROBACION_CENTRO_COSTO:
          result.pendientes++;
          break;
        case OrderState.PENDIENTE_APROBACION_AREA_COMPRAS:
          result.preaprobadas++;
          break;
      }
    }

    return result;
  }, [orders]);

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, sm: 3 }}>
        <StatCard
          title="Total"
          value={stats.total}
          sx={{ background: 'linear-gradient(135deg,#667eea,#764ba2)' }}
          onClick={onStatClick ? () => onStatClick(null) : undefined}
          selected={selectedState === null}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 3 }}>
        <StatCard
          title="Borradores"
          value={stats.borradores}
          sx={{ background: 'linear-gradient(135deg,#f6d365,#fda085)' }}
          onClick={
            onStatClick
              ? () =>
                  onStatClick(
                    selectedState === OrderState.BORRADOR
                      ? null
                      : OrderState.BORRADOR
                  )
              : undefined
          }
          selected={selectedState === OrderState.BORRADOR}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 3 }}>
        <StatCard
          title="Pendiente Centro Costo"
          value={stats.pendientes}
          sx={{ background: 'linear-gradient(135deg,#f093fb,#f5576c)' }}
          onClick={
            onStatClick
              ? () =>
                  onStatClick(
                    selectedState ===
                      OrderState.PENDIENTE_APROBACION_CENTRO_COSTO
                      ? null
                      : OrderState.PENDIENTE_APROBACION_CENTRO_COSTO
                  )
              : undefined
          }
          selected={
            selectedState === OrderState.PENDIENTE_APROBACION_CENTRO_COSTO
          }
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 3 }}>
        <StatCard
          title="Pendiente Área Compras"
          value={stats.preaprobadas}
          sx={{ background: 'linear-gradient(135deg,#5ee7df,#b490ca)' }}
          onClick={
            onStatClick
              ? () =>
                  onStatClick(
                    selectedState ===
                      OrderState.PENDIENTE_APROBACION_AREA_COMPRAS
                      ? null
                      : OrderState.PENDIENTE_APROBACION_AREA_COMPRAS
                  )
              : undefined
          }
          selected={
            selectedState === OrderState.PENDIENTE_APROBACION_AREA_COMPRAS
          }
        />
      </Grid>
    </Grid>
  );
}
